import { css } from "@emotion/react";

export const styles = {
  typography__description: css`
    word-break: break-word;
    ul,
    ol {
      padding-inline-start: 20px;
    }

    span::after {
      content: "\A"; /* Linha nova */
      white-space: pre; /* Respeita espaços em branco */
      display: block;
      margin-bottom: 10px; /* Espaçamento entre linhas */
    }
  `
};
